
(function () {
  'use strict';

  var KEY = 'tjs_cart_v1';

  // ── Shared helpers ──────────────────────────────────────────────────────────
  function loadCart() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; }
  }
  function saveCart(arr) { localStorage.setItem(KEY, JSON.stringify(arr)); }
  function toNum(p) { return parseInt(String(p).replace(/[^0-9]/g, ''), 10) || 0; }
  function fmt(n) { return '$' + Math.round(n).toLocaleString('en-US'); }

  function groupItems(raw) {
    var map = new Map();
    raw.forEach(function (it) {
      var k = [it.url || it.name, it.metal, it.length].join('|');
      if (map.has(k)) { map.get(k).qty++; }
      else { map.set(k, Object.assign({}, it, { qty: 1, unit: toNum(it.price) })); }
    });
    return Array.from(map.values());
  }

  function refreshBadge() {
    var count = loadCart().length;
    document.querySelectorAll('.tjs-bag-count, .bag-count').forEach(function (b) {
      b.textContent = String(count);
      b.style.display = count > 0 ? '' : 'none';
    });
  }

  // Keep Shopify's native cart empty — we use localStorage instead
  fetch('/cart.js')
    .then(function (r) { return r.json(); })
    .then(function (c) { if (c.item_count > 0) fetch('/cart/clear.js', { method: 'POST' }); })
    .catch(function () {});

  // ── Add-to-cart interception ────────────────────────────────────────────────
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.action || form.action.indexOf('/cart/add') === -1) return;
    e.preventDefault();
    e.stopImmediatePropagation();

    var nameEl = document.querySelector('[class*="-product-title"]') || document.querySelector('h1');
    var name   = nameEl ? nameEl.textContent.trim() : document.title;

    var priceEl = document.querySelector('[id$="-sum-total"]') || document.querySelector('[id$="-price-display"]');
    var price   = priceEl ? priceEl.textContent.trim() : '';

    var metalEl = document.querySelector('[id$="-sum-metal"]');
    var metal   = (metalEl && metalEl.textContent.trim() && metalEl.textContent.trim() !== '—') ? metalEl.textContent.trim() : '';

    var sizeEl = document.querySelector('[id$="-sum-size"]') || document.querySelector('[id$="-sum-length"]');
    var rawSz  = sizeEl ? sizeEl.textContent.trim() : '';
    var length = (rawSz && rawSz !== '—' && rawSz !== 'Not selected') ? rawSz : '';

    var imgEl = document.querySelector('[id$="-main-img"]') || document.querySelector('[class*="-main-image"] img');
    var img   = imgEl ? imgEl.src : '';

    var items = loadCart();
    items.push({ name: name, price: price, metal: metal, length: length, img: img, url: window.location.pathname });
    saveCart(items);
    refreshBadge();

    var btn = form.querySelector('button[type="submit"]');
    if (btn) {
      var orig = btn.textContent;
      btn.textContent = 'Added to Cart';
      btn.disabled = true;
      setTimeout(function () { btn.textContent = orig; btn.disabled = false; }, 1800);
    }

    openDrawer();
  }, true);

  // ── Cart drawer ─────────────────────────────────────────────────────────────
  var drawerReady = false;

  function buildDrawer() {
    if (drawerReady) return;
    drawerReady = true;

    // Styles
    var style = document.createElement('style');
    style.textContent =
      '.tjs-co-overlay{position:fixed;inset:0;z-index:9998;background:rgba(20,22,26,.45);opacity:0;pointer-events:none;transition:opacity .3s ease;}' +
      '.tjs-co-overlay.open{opacity:1;pointer-events:all;}' +
      '.tjs-co-drawer{position:fixed;top:0;right:0;bottom:0;z-index:9999;width:420px;max-width:100vw;background:#fff;display:flex;flex-direction:column;transform:translateX(100%);transition:transform .35s cubic-bezier(.4,0,.2,1);}' +
      '.tjs-co-drawer.open{transform:translateX(0);}' +
      '.tjs-co-head{display:flex;align-items:center;justify-content:space-between;padding:24px 28px;border-bottom:1px solid rgba(20,22,26,.1);flex-shrink:0;}' +
      '.tjs-co-title{font-family:"Mulish", sans-serif;font-size:11px;letter-spacing:.26em;text-transform:uppercase;font-weight:500;color:#14161A;}' +
      '.tjs-co-close{background:none;border:none;cursor:pointer;padding:4px;color:#14161A;display:flex;align-items:center;transition:opacity .2s;}' +
      '.tjs-co-close:hover{opacity:.45;}' +
      '.tjs-co-close svg{width:18px;height:18px;}' +
      '.tjs-co-body{flex:1;overflow-y:auto;padding:0 28px;}' +
      '.tjs-co-empty{display:flex;align-items:center;justify-content:center;height:120px;font-family:"Mulish", sans-serif;font-size:13px;font-weight:300;color:#3C3F45;}' +
      '.tjs-co-item{display:grid;grid-template-columns:64px 1fr auto;gap:14px;align-items:start;padding:20px 0;border-bottom:1px solid rgba(20,22,26,.08);}' +
      '.tjs-co-thumb{aspect-ratio:1/1;background:repeating-linear-gradient(135deg,transparent 0 8px,rgba(20,17,13,.035) 8px 9px),linear-gradient(180deg,rgba(255,255,255,.6),rgba(181,154,110,.10));border:1px solid rgba(20,22,26,.08);overflow:hidden;flex-shrink:0;}' +
      '.tjs-co-thumb img{width:100%;height:100%;object-fit:cover;display:block;}' +
      '.tjs-co-iname{font-family:"Playfair Display", Georgia, serif;font-style:normal;font-weight:300;font-size:17px;line-height:1.2;color:#14161A;margin-bottom:5px;}' +
      '.tjs-co-imeta{font-family:"Mulish", sans-serif;font-size:10px;letter-spacing:.12em;text-transform:uppercase;color:#3C3F45;}' +
      '.tjs-co-iright{display:flex;flex-direction:column;align-items:flex-end;gap:8px;}' +
      '.tjs-co-iprice{font-family:"Mulish", sans-serif;font-size:13px;font-weight:300;color:#14161A;white-space:nowrap;}' +
      '.tjs-co-iremove{background:none;border:none;cursor:pointer;padding:0;font-family:"Mulish", sans-serif;font-size:9.5px;letter-spacing:.16em;text-transform:uppercase;color:#3C3F45;text-decoration:underline;text-underline-offset:2px;transition:color .2s;}' +
      '.tjs-co-iremove:hover{color:#14161A;}' +
      '.tjs-co-foot{padding:22px 28px 32px;border-top:1px solid rgba(20,22,26,.1);flex-shrink:0;}' +
      '.tjs-co-subrow{display:flex;align-items:baseline;justify-content:space-between;margin-bottom:20px;}' +
      '.tjs-co-sublabel{font-family:"Mulish", sans-serif;font-size:11px;letter-spacing:.22em;text-transform:uppercase;font-weight:500;color:#14161A;}' +
      '.tjs-co-subval{font-family:"Playfair Display", Georgia, serif;font-style:normal;font-size:26px;color:#14161A;}' +
      '.tjs-co-checkout{display:block;width:100%;padding:17px;background:#14161A;color:#fff;font-family:"Mulish", sans-serif;font-size:11px;letter-spacing:.26em;text-transform:uppercase;text-align:center;text-decoration:none;border:1px solid #14161A;transition:background .25s,color .25s;margin-bottom:12px;box-sizing:border-box;}' +
      '.tjs-co-checkout:hover{background:transparent;color:#14161A;}' +
      '.tjs-co-shipnote{font-family:"Mulish", sans-serif;font-size:11px;font-weight:300;color:#3C3F45;text-align:center;letter-spacing:.02em;}';
    document.head.appendChild(style);

    // Overlay
    var overlay = document.createElement('div');
    overlay.id = 'tjs-co-overlay';
    overlay.className = 'tjs-co-overlay';
    overlay.addEventListener('click', closeDrawer);
    document.body.appendChild(overlay);

    // Drawer
    var drawer = document.createElement('aside');
    drawer.id = 'tjs-co-drawer';
    drawer.className = 'tjs-co-drawer';
    drawer.innerHTML =
      '<div class="tjs-co-head">' +
        '<span class="tjs-co-title">Your Bag</span>' +
        '<button class="tjs-co-close" aria-label="Close">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4"><path d="M18 6L6 18M6 6l12 12"/></svg>' +
        '</button>' +
      '</div>' +
      '<div class="tjs-co-body" id="tjs-co-body"></div>' +
      '<div class="tjs-co-foot" id="tjs-co-foot">' +
        '<div class="tjs-co-subrow">' +
          '<span class="tjs-co-sublabel">Subtotal</span>' +
          '<span class="tjs-co-subval" id="tjs-co-subval">$0</span>' +
        '</div>' +
        '<a href="/cart" class="tjs-co-checkout">Checkout</a>' +
        '<p class="tjs-co-shipnote">Shipping &amp; taxes calculated at checkout</p>' +
      '</div>';
    document.body.appendChild(drawer);

    drawer.querySelector('.tjs-co-close').addEventListener('click', closeDrawer);

    // Remove via delegation
    drawer.querySelector('#tjs-co-body').addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('.tjs-co-iremove');
      if (!btn) return;
      var key = decodeURIComponent(btn.dataset.key);
      var raw = loadCart();
      var idx = raw.findIndex(function (it) {
        return [it.url || it.name, it.metal, it.length].join('|') === key;
      });
      if (idx !== -1) raw.splice(idx, 1);
      saveCart(raw);
      refreshBadge();
      renderDrawer();
      cartRender(); // sync cart page if open
    });
  }

  function renderDrawer() {
    var body   = document.getElementById('tjs-co-body');
    var foot   = document.getElementById('tjs-co-foot');
    var subval = document.getElementById('tjs-co-subval');
    if (!body) return;

    var items = groupItems(loadCart());

    if (!items.length) {
      body.innerHTML = '<div class="tjs-co-empty">Your bag is empty.</div>';
      if (foot) foot.style.display = 'none';
      return;
    }
    if (foot) foot.style.display = '';

    body.innerHTML = items.map(function (it) {
      var k = encodeURIComponent([it.url || it.name, it.metal, it.length].join('|'));
      return '<div class="tjs-co-item">' +
        '<div class="tjs-co-thumb">' + (it.img ? '<img src="' + it.img + '" alt="">' : '') + '</div>' +
        '<div>' +
          '<div class="tjs-co-iname">' + (it.name || '') + '</div>' +
          '<div class="tjs-co-imeta">' + ([it.metal, it.length].filter(Boolean).join(' · ') || 'Fine jewelry') + '</div>' +
        '</div>' +
        '<div class="tjs-co-iright">' +
          '<div class="tjs-co-iprice">' + fmt(it.unit * it.qty) + '</div>' +
          '<button class="tjs-co-iremove" data-key="' + k + '">Remove</button>' +
        '</div>' +
        '</div>';
    }).join('');

    if (subval) subval.textContent = fmt(items.reduce(function (s, it) { return s + it.unit * it.qty; }, 0));
  }

  function openDrawer() {
    buildDrawer();
    renderDrawer();
    document.getElementById('tjs-co-overlay').classList.add('open');
    document.getElementById('tjs-co-drawer').classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    var o = document.getElementById('tjs-co-overlay');
    var d = document.getElementById('tjs-co-drawer');
    if (o) o.classList.remove('open');
    if (d) d.classList.remove('open');
    document.body.style.overflow = '';
  }

  window.tjsOpenCartDrawer = openDrawer;

  // ── Cart page ───────────────────────────────────────────────────────────────
  var TAX_RATE = 0.08875;
  var PROMOS   = { 'STANDARD10': { type: 'pct', val: 0.10, label: '10% welcome credit' }, 'INSIDER': { type: 'flat', val: 250, label: '$250 client credit' } };
  var DELIVERY = {
    domestic: { ship: 0,  title: 'Insured Express Domestic Shipping', sub: '1–2 business days · signature required', price: 'Complimentary', free: true,  eta: '1–2 business days' },
    intl:     { ship: 95, title: 'International Shipping',            sub: 'Fully insured & tracked · duties at destination', price: '$95', free: false, eta: '7–10 business days' }
  };
  var cartState = { discount: 0, shipping: 0, method: DELIVERY.domestic };

  function cartGet(id) { return document.getElementById(id); }
  function cartSet(id, v) { var el = cartGet(id); if (el) el.textContent = v; }

  function cartRecalc() {
    var items    = groupItems(loadCart());
    var subtotal = items.reduce(function (s, it) { return s + it.unit * it.qty; }, 0);
    var taxable  = Math.max(0, subtotal - cartState.discount);
    var tax      = taxable * TAX_RATE;
    var total    = taxable + cartState.shipping + tax;
    cartSet('lineSubtotal', fmt(subtotal));
    cartSet('lineTax',      fmt(tax));
    cartSet('lineTotal',    fmt(total));
    cartSet('placeTotal',   fmt(total));
    var dl = cartGet('discountLine'), ld = cartGet('lineDiscount');
    if (dl && ld) { dl.style.display = cartState.discount > 0 ? '' : 'none'; if (cartState.discount > 0) ld.textContent = '–' + fmt(cartState.discount); }
    var ls = cartGet('lineShipping');
    if (ls) ls.textContent = cartState.shipping === 0 ? 'Free' : fmt(cartState.shipping);
  }

  function cartRender() {
    var sumEl = cartGet('sumItems');
    if (!sumEl) return;
    var wrap  = cartGet('checkoutWrap');
    var empty = cartGet('emptyState');
    var items = groupItems(loadCart());
    if (!items.length) {
      saveCart([]);
      refreshBadge();
      if (wrap)  wrap.style.display  = 'none';
      if (empty) empty.style.display = '';
      return;
    }
    if (wrap)  wrap.style.display  = '';
    if (empty) empty.style.display = 'none';
    sumEl.innerHTML = items.map(function (it) {
      var k = encodeURIComponent([it.url || it.name, it.metal, it.length].join('|'));
      return '<div class="sum-item">' +
        '<div class="sum-thumb">' + (it.qty > 1 ? '<span class="sum-qty">' + it.qty + '</span>' : '') + '</div>' +
        '<div><div class="sum-item-name">' + (it.name || '') + '</div>' +
        '<div class="sum-item-meta">' + ([it.metal, it.length].filter(Boolean).join(' · ') || 'Fine jewelry') + '</div></div>' +
        '<div class="sum-item-right"><div class="sum-item-price">' + fmt(it.unit * it.qty) + '</div>' +
        '<button class="sum-item-remove" data-key="' + k + '">Remove</button></div></div>';
    }).join('');
    cartRecalc();
  }

  function initCartPage() {
    var sumEl = cartGet('sumItems');
    if (!sumEl || sumEl.dataset.tjsInit) return;
    sumEl.dataset.tjsInit = '1';
    cartState.discount = 0; cartState.shipping = 0; cartState.method = DELIVERY.domestic;
    cartRender();
    refreshBadge();

    sumEl.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('.sum-item-remove');
      if (!btn) return;
      var key = decodeURIComponent(btn.dataset.key);
      var raw = loadCart();
      var idx = raw.findIndex(function (it) { return [it.url || it.name, it.metal, it.length].join('|') === key; });
      if (idx !== -1) raw.splice(idx, 1);
      saveCart(raw);
      refreshBadge();
      cartRender();
    });

    var countrySel = cartGet('country');
    function updateDelivery() {
      cartState.method   = countrySel && countrySel.value === 'United States' ? DELIVERY.domestic : DELIVERY.intl;
      cartState.shipping = cartState.method.ship;
      var dt = cartGet('deliveryTitle'), ds = cartGet('deliverySub'), dp = cartGet('deliveryPrice');
      if (dt) dt.textContent = cartState.method.title;
      if (ds) ds.textContent = cartState.method.sub;
      if (dp) { dp.textContent = cartState.method.price; dp.className = 'opt-price' + (cartState.method.free ? ' free' : ''); }
      cartRecalc();
    }
    if (countrySel) { countrySel.addEventListener('change', updateDelivery); updateDelivery(); }

    var promoApply = cartGet('promoApply'), promoInput = cartGet('promoInput'), promoMsg = cartGet('promoMsg');
    function applyPromo() {
      var code = ((promoInput && promoInput.value) || '').trim().toUpperCase();
      if (!code) { if (promoMsg) { promoMsg.textContent = ''; promoMsg.className = 'promo-msg'; } return; }
      var p = PROMOS[code];
      var sub = groupItems(loadCart()).reduce(function (s, it) { return s + it.unit * it.qty; }, 0);
      if (!p) { cartState.discount = 0; if (promoMsg) { promoMsg.textContent = "That code isn't recognized. Try STANDARD10."; promoMsg.className = 'promo-msg err'; } }
      else { cartState.discount = p.type === 'pct' ? sub * p.val : Math.min(p.val, sub); if (promoMsg) { promoMsg.textContent = 'Applied — ' + p.label + '.'; promoMsg.className = 'promo-msg ok'; } }
      cartRecalc();
    }
    if (promoApply) promoApply.addEventListener('click', applyPromo);
    if (promoInput) promoInput.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); applyPromo(); } });

    var form = cartGet('checkoutForm'), placeBtn = cartGet('placeOrder');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var req = form.querySelectorAll('[required]'), ok = true, firstBad = null;
        req.forEach(function (f) {
          var bad = !f.value || (f.type === 'email' && !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(f.value));
          f.style.borderColor = bad ? '#9A4B43' : ''; f.style.boxShadow = bad ? '0 0 0 1px #9A4B43' : '';
          if (bad && !firstBad) firstBad = f; if (bad) ok = false;
        });
        if (!ok) { if (firstBad) firstBad.focus(); return; }
        if (placeBtn) { placeBtn.disabled = true; placeBtn.innerHTML = 'Processing…'; }
        setTimeout(showConfirmation, 1100);
      });
    }

    function showConfirmation() {
      var emailEl = cartGet('email');
      var items   = groupItems(loadCart());
      var sub     = items.reduce(function (s, it) { return s + it.unit * it.qty; }, 0);
      var taxable = Math.max(0, sub - cartState.discount);
      var total   = taxable + cartState.shipping + taxable * TAX_RATE;
      var orderNo = 'TJS-' + Math.floor(100000 + Math.random() * 900000);
      saveCart([]); refreshBadge();
      var cw = cartGet('checkoutWrap'); if (cw) cw.style.display = 'none';
      var c = document.createElement('div'); c.className = 'co-confirm';
      c.innerHTML =
        '<div class="confirm-mark"><svg viewBox="0 0 26 26" fill="none" stroke="currentColor" stroke-width="1.3"><path d="M6 13.5l4.5 4.5L20 7.5"/></svg></div>' +
        '<div class="confirm-eyebrow">Order Confirmed</div>' +
        '<h1 class="confirm-title">Thank you — your<br>order is on its way.</h1>' +
        '<p class="confirm-copy">A confirmation has been sent to <b>' + (emailEl ? emailEl.value : 'your inbox') + '</b>. Each piece is inspected and hand-finished before it ships, fully insured and signature-required.</p>' +
        '<div class="confirm-meta">' +
          '<div class="cm"><span class="k">Order</span><span class="vv">' + orderNo + '</span></div>' +
          '<div class="cm"><span class="k">Total</span><span class="vv">' + fmt(total) + '</span></div>' +
          '<div class="cm"><span class="k">' + cartState.method.title + '</span><span class="vv">' + cartState.method.eta + '</span></div>' +
        '</div>' +
        '<div class="confirm-actions"><a class="solid" href="/">Back to home</a><a class="ghost" href="/collections/fine-jewelry">Continue shopping</a></div>';
      var coWrap = document.querySelector('.co-wrap'); if (coWrap) coWrap.insertAdjacentElement('afterend', c);
      window.scrollTo({ top: 0, behavior: 'auto' });
    }
  }

  // ── Navigation detection ────────────────────────────────────────────────────
  var _push = history.pushState.bind(history);
  history.pushState = function () {
    _push.apply(history, arguments);
    setTimeout(function () { initCartPage(); refreshBadge(); }, 80);
  };
  window.addEventListener('popstate', function () {
    setTimeout(function () { initCartPage(); refreshBadge(); }, 80);
  });

  refreshBadge();
  initCartPage();

})();
